'use strict';

var util = angular.module('gymsystem.util');

util.factory('Link', ['$rootScope', '$q', '$injector', '$filter', function($rootScope, $q, $injector, $filter) {
    var isStaffApp = function() {return !!$rootScope.getMember;};
    var objCache = {}, transform;

    function Link(type, id) {
        if(!(this instanceof Link)) {return new Link(type, id);}

        if(type && id) {
            this.type = type;
            this.id = id;
            return this;
        } else if(type) {
            if(type.$link) {
                this.type = type.$link;
                this.id = type.id;
                return this;
            }

        }
        throw 'Wrong link';
    }

    Link.prototype.toString = function() {
        return '{' + this.type + ':' + this.id + '}';
    };

    Link.prototype.getObjectSync = function() {
        if(this._cache) {return this._cache;}
        if(objCache[this.toString()]) {return objCache[this.toString()];}
        var result;

        if(isStaffApp()) {
            if(this.type === 'member') {
                result = $rootScope.getMember(this.id);
            } else if(this.type === 'user') {
                result = $rootScope.getMember(this.id);
            } else if(this.type === 'staff') {
                result = $rootScope.getStaff(this.id);
            } else if(this.type === 'trainingcardtype') {
                result = $rootScope.getPointerById(this.id, $rootScope.trainingcardtypes);
            } else if(this.type === 'paymentmethod') {
                result = _.findWhere($rootScope.paymentmethods, {_id: this.id});
            } else if(this.type === 'cashregister') {
                result = _.findWhere($rootScope.cashregisters, {id: this.id});
            } else if(this.type === 'resourcebookingservice') {
                result = _.findWhere($rootScope.resourcebookingservices, {id: this.id});
            } else if(this.type === 'role') {
                result = _.findWhere($rootScope.roles, {id: this.id});
            }
        }

        if(result) {
            this._cache = result;
        }
        return result;
    };

    Link.prototype.getObject = function() {
        var deferred = $q.defer();
        var obj = this.getObjectSync();
        if(obj) {
            deferred.resolve(obj);
        } else {
            var server = $injector.get('server');
            if(this.type === 'trainingcard' && isStaffApp()) {
                server.get('/api/trainingcard/get?id='+this.id).then(function(response) {
                    var trainingcard = $rootScope.transformTrainingCard(response);
                    deferred.resolve(trainingcard);
                }, deferred.reject);
            } else if(this.type === 'resourcebookingservice' || this.type === 'trainingcardtype' || this.type === 'workout') {
                var self = this;
                server.post2('/api/public/db/search', {
                    query: {type: this.type, id: this.id}
                }).then(function(response) {
                    if(response.result.length) {
                        response.result.forEach(transform);
                        self._cache = self.getObjectSync();
                        deferred.resolve(self._cache);
                    } else {
                        deferred.reject();
                    }
                }, deferred.reject);
            } else {
                deferred.reject();
            }
        }
        return deferred.promise;
    };

    Link.prototype.getNameSync = function() {
        if(this.type === 'staff' && this.id === 1) {
            return $filter('translate')('Zoezi support');
        }
        var obj = this.getObjectSync();
        if(obj) {
            return obj.name;
        }
        return this.toString();
    };

    var constructor = {
        resourcebookingservice: (function(){
            function ResourceBookingService(data) {
                for(var k in data) {
                    this[k] = data[k];
                }
            }

            ResourceBookingService.prototype.getPrice = function() {
                var tc = this.trainingcard_link.getObjectSync();
                return tc.price;
            };

            return function(data) {
                return new ResourceBookingService(data);
            };
        })(),

        workout: (function() {
            function Workout(data) {
                _.extend(this, data);
            }

            Workout.prototype.getName = function() {
                var name = this.workoutType.name;
                if (this.status == 'Cancelled') {
                    name += ' - ' + $filter('translate')('Cancelled');
                }
                return name;
            };

            Workout.prototype.getPrice = function() {
                return this.workoutType.price;
            };

            return function(data) {
                return new Workout(data);
            };
        })(),

        trainingcardtype: (function() {
            function TrainingCardType(data) {
                _.extend(this, data);
            }

            TrainingCardType.prototype.isProduct = function() {
                return (!this.boundTime && !this.boundType && !this.validTime && !this.validType && (!this.priceType || this.priceType === 'OneTime') && !this.trainingsessions) || this.giftcard || this.valuecard;
            };

            return function(data) {
                return new TrainingCardType(data);
            };
        })()
    };

    transform = function(data) {
        var obj, link = data.__link;

        if(constructor[link.type]) {
            obj = constructor[link.type](data);
        } else {
            obj = data;
        }
        var key = link.toString();
        objCache[key] = obj;
        return obj;
    };

    return Link;
}]);

util.filter('link', ['Link', function(Link) {
    return function(link) {
        if(!link) {return '';}
        if(link instanceof Link) {
            return link.getNameSync();
        }
        return '';
    };
}]);
